export default "__VITE_ASSET__CehSVUD2__"